import React, { createContext, useContext, useEffect, useState } from 'react';
import Animation from '../../../components/Animation';
import { FetchCallbacksContext } from '../../FetchCallbacks';
import { FormBuilderContext } from '../../../components/engine/FormBuilderEngine';
import FormBuilderDocusignEngine from '../engine/FormBuilderDocusignEngine';
import FormBuilderThirdfortEngine from '../engine/FormBuilderThirdfortEngine';
import FormBuilderWorldcheckEngine from '../engine/FormBuilderWorldcheckEngine';
import FormBuilderCredasEngine from '../engine/FormBuilderCredasEngine';
import FormBuilderIntegrationsView from '../view/FormBuilderIntegrationsView';
import getUrlParam from '../../../utils/getUrlParam';
import useFetchWithCallbacks from '../../../hooks/useFetchWithCallbacks';

const Integrations = {
  DOCUSIGN: 'docusign',
  THIRDFORT: 'thirdfort',
  WORLDCHECK: 'worldcheck',
  CREDAS: 'credas'
};

export const FormBuilderIntegrationsContext = createContext({});

const FormBuilderIntegrationsEngine = ({
  formId,
  pageId,
  form = {},
  dispatch
}) => {
  const fetchAPI = useFetchWithCallbacks();
  const { openSnackbar } = useContext(FetchCallbacksContext);
  const { setCurrentStage } = useContext(FormBuilderContext);

  const [currentIntegrationPage, setCurrentIntegrationPage] = useState('');
  const [docusignData, setDocusignData] = useState({ id: 'new' });
  const [thirdfortData, setThirdfortData] = useState({ id: 'new' });
  const [worldcheckData, setWorldcheckData] = useState({ id: 'new' });
  const [credasData, setCredasData] = useState({ id: 'new' });
  const [updatedTemplate, setUpdatedTemplate] = useState(false);
  const [licensed, setLicensed] = useState(0);
  const [thirdfortLicensed, setThirdfortLicensed] = useState(0);
  const [worldcheckLicensed, setWorldcheckLicensed] = useState(0);
  const [credasLicensed, setCredasLicensed] = useState(0);
  const [checkedAndNotConnecting, setCheckedAndNotConnecting] = useState(false);

  const clickedAnonymous = () => {
    // let newLocation, parts, lastPart;
    // newLocation = window.location.href;
    // parts = newLocation.split('/');
    // lastPart = parts[parts.length - 1];
    // if (lastPart === formId) {
    //   newLocation += '/share';
    //   window.location.href = newLocation;
    // } else if (lastPart === 'share') {
    //   window.location.reload();
    // }

    setCurrentStage('share');
  };

  const setCurrentIntegrationPageWrapper = (val, skipConfirm = false) => {
    let answer;
    if (val === '') {
      reloadIntegrationData();
    }
    setCurrentIntegrationPage(val);
  };

  const goBackToIntegrationsPage = (params = {}) => {
    setCurrentIntegrationPageWrapper('', params.skipConfirm);
    reloadIntegrationData();
  };

  const gotoDocusignPage = () => {
    setCurrentIntegrationPage('docusign');
  };

  const gotoThirdfortPage = () => {
    setCurrentIntegrationPage('thirdfort');
  };

  const gotoWorldcheckPage = () => {
    setCurrentIntegrationPage('worldcheck');
  };

  const gotoCredasPage = () => {
    setCurrentIntegrationPage('credas');
  };

  const reloadIntegrationData = (
    gotoPage,
    showConnectedSnackbar,
    newReportId
  ) => {
    if (formId) {
      fetchAPI(
        `/scheduler/v1/integration?query=[[{"field":"'assetId'","op":"=","value":"${formId}"}]]`
      ).then(res => {
        const docusignResults =
          res && res.results
            ? res.results.filter(one => one.integrationType === 'docusign')
            : [];
        const thirdfortResults =
          res && res.results
            ? res.results.filter(one => one.integrationType === 'thirdfort')
            : [];
        const worldcheckResults =
          res && res.results
            ? res.results.filter(one => one.integrationType === 'worldcheck')
            : [];
        const credasResults =
          res && res.results
            ? res.results.filter(one => one.integrationType === 'credas')
            : [];
        if (docusignResults.length) {
          if (newReportId) {
            docusignResults[0].additionalParams.reportData.template =
              newReportId;
          }
          setDocusignData(docusignResults[0]);
          setUpdatedTemplate(newReportId);
          if (gotoPage) {
            setCurrentIntegrationPageWrapper(gotoPage);
            if (showConnectedSnackbar) {
              openSnackbar(
                'success',
                'snackbars.integrations.docusign_success'
              );
            }
          } else {
            setCheckedAndNotConnecting(true);
          }
        } else {
          setDocusignData({ id: 'new' });
          setCheckedAndNotConnecting(true);
        }
        if (thirdfortResults.length) {
          setThirdfortData(thirdfortResults[0]);
        } else {
          setThirdfortData({ id: 'new' });
        }
        if (worldcheckResults.length) {
          setWorldcheckData(worldcheckResults[0]);
        } else {
          setWorldcheckData({ id: 'new' });
        }
        if (credasResults.length) {
          setCredasData(credasResults[0]);
        } else {
          setCredasData({ id: 'new' });
        }
      });
    } else {
      setCheckedAndNotConnecting(true);
    }
  };

  useEffect(() => {
    let connect, showIntegration, newReportId;
    connect = getUrlParam('connect') || '';
    showIntegration = getUrlParam('showIntegration') || '';
    newReportId = getUrlParam('tId') || '';
    fetchAPI(
      `/configurations/v1/modules/license?order=id asc&query=[[{"field":"'module'","op":"=","value":"provisioning"},{"field":"'configName'","op":"=","value":"license"}]]`
    )
      .then(res => {
        let a, n;
        const docusignResults =
          res && res.configs
            ? res.configs.filter(one => one.code === 'docusign')
            : [];
        a = docusignResults.length && docusignResults[0].value;
        n = Number(a) || 0;
        setLicensed(n);
        const thirdfortResults =
          res && res.configs
            ? res.configs.filter(one => one.code === 'thirdfort')
            : [];
        a = thirdfortResults.length && thirdfortResults[0].value;
        n = Number(a) || 0;
        setThirdfortLicensed(n);
        const worldcheckResults =
          res && res.configs
            ? res.configs.filter(one => one.code === 'worldcheck')
            : [];
        a = worldcheckResults.length && worldcheckResults[0].value;
        n = Number(a) || 0;
        setWorldcheckLicensed(n);
        const credasResults =
          res && res.configs
            ? res.configs.filter(one => one.code === 'credas')
            : [];
        a = credasResults.length && credasResults[0].value;
        n = Number(a) || 0;
        setCredasLicensed(n);
      })
      .catch(e => {});
    reloadIntegrationData(connect || showIntegration, connect, newReportId);
    if (connect || showIntegration || newReportId) {
      window.history.replaceState &&
        window.history.replaceState(
          null,
          '',
          window.location.pathname +
            window.location.search
              .replace(/[\?&](connect|showIntegration|tId)=[^&]+/g, '')
              .replace(/^&/, '?')
        );
    } else {
      setCheckedAndNotConnecting(true);
    }
  }, []);

  const viewProps = {
    anonymous: form && form.sharingType === 'anonymous',
    licensed,
    thirdfortLicensed,
    worldcheckLicensed,
    credasLicensed,
    clickedAnonymous,
    gotoDocusignPage,
    gotoThirdfortPage,
    gotoWorldcheckPage,
    gotoCredasPage,
    docusignData,
    thirdfortData,
    worldcheckData,
    credasData,
    checkedAndNotConnecting
  };

  const contextProps = {
    setCurrentIntegrationPage: setCurrentIntegrationPageWrapper
  };

  return (
    <FormBuilderIntegrationsContext.Provider value={contextProps}>
      <Animation
        mountOnEnter
        unmountOnExit
        type="collapse"
        in={!Object.values(Integrations).includes(currentIntegrationPage)}
      >
        <FormBuilderIntegrationsView {...viewProps} />
      </Animation>
      <Animation
        type="collapse"
        mountOnEnter
        unmountOnExit
        in={Integrations.DOCUSIGN === currentIntegrationPage}
      >
        <FormBuilderDocusignEngine
          {...{
            formId,
            pageId,
            form,
            goBackToIntegrationsPage,
            integrationData: docusignData,
            updatedTemplate
          }}
        />
      </Animation>
      <Animation
        type="collapse"
        mountOnEnter
        unmountOnExit
        in={Integrations.THIRDFORT === currentIntegrationPage}
      >
        <FormBuilderThirdfortEngine
          {...{
            formId,
            pageId,
            form,
            goBackToIntegrationsPage,
            integrationData: thirdfortData,
            updatedTemplate,
            dispatch
          }}
        />
      </Animation>
      <Animation
        type="collapse"
        mountOnEnter
        unmountOnExit
        in={Integrations.WORLDCHECK === currentIntegrationPage}
      >
        <FormBuilderWorldcheckEngine
          {...{
            formId,
            pageId,
            form,
            goBackToIntegrationsPage,
            integrationType: 'worldcheck',
            integrationDisplayName: 'Refinitiv World-Check',
            integrationData: worldcheckData,
            updatedTemplate,
            dispatch
          }}
        />
      </Animation>
      <Animation
        type="collapse"
        mountOnEnter
        unmountOnExit
        in={Integrations.CREDAS === currentIntegrationPage}
      >
        <FormBuilderCredasEngine
          {...{
            formId,
            pageId,
            form,
            goBackToIntegrationsPage,
            integrationType: 'credas',
            integrationDisplayName: 'Credas',
            integrationData: credasData,
            updatedTemplate,
            dispatch
          }}
        />
      </Animation>
    </FormBuilderIntegrationsContext.Provider>
  );
};

export default FormBuilderIntegrationsEngine;
